export const commonPMs = ["CARD", "APPLEPAY", "GOOGLEPAY", "PAYPAL"];
export const eSIMCrewPMs = ["GCASH", "PAYMAYA", "GRABPAY"];
export const eSimplePMs = ["IDEALPAY"];
export const commonPayments = [
  {
    CARD: "1",
  },
  {
    APPLEPAY: "2",
  },
  {
    PAYPAL: "3",
  },
  {
    GOOGLEPAY: "4",
  },
];

export const eSIMCrewPayments = [
  ...commonPayments,
  {
    GCASH: "6",
  },
  {
    PAYMAYA: "7",
  },
  {
    GRABPAY: "8",
  },
];

export const eSimplePayments = [
  ...commonPayments,
  {
    IDEALPAY: "5",
  },
];
